import { useEffect, useRef, useState } from "react";
import "./header.css";
import { Link, useNavigate } from "react-router-dom";
import { userAction } from "../../redux/slices/userSlice";
import { useSelector, useDispatch } from "react-redux";
import Sikh from "../../../src/assets/images/img/SikhLogo.png";
import Magisticlogo from "../../../src/assets/images/img/megisticLogo2.png";
import { FaUsers, FaCompass } from "react-icons/fa";
import { fetchUserDetails } from "./Data";
import { Button, Menu, MenuItem, Fade, styled, Badge } from "@mui/material";
import { AiFillCaretDown } from "react-icons/ai";
import "../../styles/bottom_navigate.css";
import { useLocation } from "react-router-dom";
import { FaInbox, FaPhoneAlt, FaBell } from "react-icons/fa";
import { MyCart } from "./MyCart";
import { toast } from "react-toastify";
import {
  fetchTemplates,
  setActiveTemps,
  setMyTemplates,
  setPendingTemps,
} from "../../redux/slices/TemplateSlice";
import DonateModal from "./modals/DonateModal";
import {
  setDonationFrom,
  setDonationStatus,
} from "../../redux/slices/DonationSlice";
import ThankYouModal from "../../pages/DashboardPages/Orders/ThankYouPage";
import axiosClient from "../../axios-client";
import { useSocket } from "../../contexts/SocketContext";
import SelectGurdwaraModal from "./SelectGurdwaraModal";
import { resetImageData } from "../../redux/slices/ImageSlice";
import Notification from "../Layout/Notification";
import { MdMenu } from "react-icons/md";

const Header = ({ setOpen, isOpen }) => {
  const location = useLocation();
  const { headerCounts } = useSelector((state) => state.user);
  const isBrowsePage = location.pathname === "/weddingvendors";
  const isMajesticHomePage = location.pathname === "/majesticHomePage";
  const isVendorDetailsPage = location.pathname.includes("/vendordetails");
  const isInvoicePaymentPage = location.pathname.includes("/invoicePayment");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const islogin = useSelector((state) => state.user.isLogin);
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;
  const isAdmin = user && user.Role === "admin";
  const [userDetails, setUserDetails] = useState({});
  const [unreadMsg, setUnreadMsg] = useState(0);
  const { AllTemplates } = useSelector((state) => state.templates);
  const [modal, setModal] = useState(false);
  const [anchorVendors, setAnchorVendors] = useState(null);
  const openVendors = Boolean(anchorVendors);
  const [gurdwaraId, setGurdwaraId] = useState(null);
  const [showNotifications, setShowNotifications] = useState(false);
  const { notifications } = useSelector((state) => state.media);
  const [gurdwaraName, setGurdwaraName] = useState("");
  const { donationStatus, donationFrom } = useSelector(
    (state) => state.gurdwaraDonation
  );
  const hasFetchedData = useRef(false);
  const { tasks } = useSelector((state) => state.media);
  const isUploadInProgress = tasks.some((task) => task.progress < 100);
  const { socket } = useSocket();
  const [thankYou, setThankYou] = useState(false);
  const [anchorEl22, setAnchorEl22] = useState(null);
  const [anchorCall, setAnchorCall] = useState(null);
  const open22 = Boolean(anchorEl22);
  const openCall = Boolean(anchorCall);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalClosed, setModalClosed] = useState(false);
  const [showCollapse, setShowCollapse] = useState(false);
  let maxLength = 8;
  let truncatedUsername = "";
  const isProfileComplete = !!(
    user &&
    user.FirstName &&
    user.LastName &&
    user.Email &&
    user.Phone &&
    user.UserName &&
    user.Radius &&
    user.Location &&
    user.ZipCode
  );
  useEffect(() => {
    if (donationFrom === "HEADER" && donationStatus === "COMPLETED") {
      setModalIsOpen(false);
      setModalClosed(true);
      dispatch(setDonationStatus(""));
      dispatch(setDonationFrom(""));
      setThankYou(true);
    }
  }, [donationStatus]);

  const StyledBadge = styled(Badge)(({ theme }) => ({
    "& .MuiBadge-badge": {
      right: -3,
      top: 1,
      border: `2px solid ${theme.palette.background.paper}`,
      backgroundColor: "var(--button-bg)",
      padding: "0 4px",
    },
  }));
  const fetchData = async () => {
    if (!user) return;
    const userData = await fetchUserDetails(user?.UserID);
    setUserDetails(userData);
    try {
      const response = await axiosClient.put(
        `message/TotalUnreadMsgByUser/${user.UserID}`
      );
      if (response.data.statusCode === 200) {
        setUnreadMsg(response.data.Data[0].total_count);
      } else {
        console.log(response.data.msg);
      }
    } catch (error) {
      throw new Error("Error fetching userDetails");
    }
  };
  useEffect(() => {
    if (islogin && !hasFetchedData.current) {
      // fetchData();
      if (isAdmin) {
        dispatch(fetchTemplates());
      }
      hasFetchedData.current = true;
    }
  }, [islogin, isAdmin]);
  const filterTemplates = () => {
    if (!AllTemplates) return { pending: [], active: [], myTemplates: [] };
    let myTemplates = [];
    let pendingTemplates = [];
    let activeTemplates = [];
    if (isAdmin) {
      myTemplates = AllTemplates;
      pendingTemplates = AllTemplates.filter(
        (template) => template.template_status == 0
      );
      activeTemplates = AllTemplates.filter(
        (template) => template.template_status == 1
      );
    } else {
      myTemplates = AllTemplates.filter(
        (template) => template.createdBy == user?.UserID
      );
      pendingTemplates = myTemplates.filter(
        (template) => template.template_status == 0
      );
      activeTemplates = myTemplates.filter(
        (template) => template.template_status == 1
      );
    }
    return {
      pending: pendingTemplates,
      active: activeTemplates,
      myTemplates: myTemplates,
    };
  };
  const { pending, active, myTemplates } = filterTemplates();
  useEffect(() => {
    if (islogin) {
      dispatch(setPendingTemps(pending));
      dispatch(setActiveTemps(active));
      dispatch(setMyTemplates(myTemplates));
    }
  }, [AllTemplates]);
  const handleClick22 = (event) => {
    setAnchorEl22(event.currentTarget);
  };
  const handleClickCall = (event) => {
    setAnchorCall(event.currentTarget);
  };
  const handleClose22 = () => {
    setAnchorEl22(null);
  };
  const handleDonate = () => {
    if (islogin && !isProfileComplete) {
      toast.info("Please complete your profile.");
      return;
    }
    dispatch(setDonationFrom("HEADER"));
    setModalIsOpen(true);
    setAnchorEl22(null);
  };
  const handleCloseCall = () => {
    setAnchorCall(null);
  };
  // useEffect(() => {
  //   if (socket) {
  //     console.log(socket, "receive-message");
  //     socket.on("receive-message", (message) => {
  //       console.log(socket, "receive-message");
  //       fetchData();
  //     });
  //     socket.on("new-message", (message) => {
  //       console.log(socket, "receive-message");
  //       fetchData();
  //     });
  //   }
  // }, [socket]);
  const userLogout = () => {
    if (isUploadInProgress) {
      toast.warn("You cannot log out while media is uploading", {
        autoClose: 5000,
        // position: "top-center",
      });
      return;
    }
    dispatch(userAction.logout());
    setAnchorEl22(null);
    navigate("/login");
    setAnchorCall(null);
  };
  if (islogin) {
    truncatedUsername =
      user?.UserName?.length > maxLength
        ? `${user.UserName.split("@")[0].trim().slice(0, maxLength)}...`
        : user.UserName.split("@")[0].trim();
  }
  const toggleCollapse = () => {
    setShowCollapse(!showCollapse);
  };
  const handleNavigation = (path, event) => {
    event.preventDefault();
    if (!islogin) {
      if (path === "/people-in-mycommunity" || path === "/items-for-sale") {
        toast.info("Please log in to access this section!");
        setShowCollapse(false);
        return;
      }
      navigate(path);
    } else if (islogin && !isProfileComplete) {
      if (path === "/dashboardpage/settings") {
        navigate(path);
      } else {
        toast.info("Please complete your profile.");
        setShowCollapse(false);
        return;
      }
    } else {
      navigate(path);
    }
    setShowCollapse(false);
  };
  const handlePeopleClick = (event) => {
    handleNavigation("/people-in-mycommunity", event);
  };
  const handleItemsClick = (event) => {
    handleNavigation("/items-for-sale", event);
  };
  const handleInboxClick = () => {
    // if (islogin && !isProfileComplete) {
    //   toast.info("Please complete your profile.");
    //   return;
    // }
    navigate("/dashboardpage/inbox");
    // islogin ? navigate("/dashboardpage/inbox") : navigate("/login");
  };
  document.addEventListener("click", function (event) {
    var isClickInside = document
      .querySelector(".navbar")
      ?.contains(event.target);
    if (!isClickInside) {
      var navbarToggler = document.querySelector(".navbar-toggler");
      var navbarCollapse = document.querySelector(".navbar-collapse");
      if (navbarCollapse?.classList?.contains("show")) {
        navbarToggler.click();
      }
    }
  });
  const toggleGurdwaraModal = () => {
    const isIpad =
      /iPad|Macintosh/i.test(navigator.userAgent) && "ontouchstart" in window;
    const isIpadPro =
      (isIpad && window.innerWidth === 1024 && window.innerHeight === 1366) ||
      (window.innerWidth === 1366 && window.innerHeight === 1024) ||
      (window.innerWidth === 834 && window.innerHeight === 1194) ||
      (window.innerWidth === 1194 && window.innerHeight === 834);

    // if (!islogin && !isIpad && !isIpadPro) {
    //   toast.info("Please login to book a Gurdwara.");
    //   return;
    // }
    if (!isOpen && !isProfileComplete && islogin) {
      toast.info("Please complete your profile.");
      return;
    }
    setGurdwaraId(null);
    setGurdwaraName("");
    setModal(!modal);
  };
  useEffect(() => {
    if (donationFrom === "FOOTER" && donationStatus === "COMPLETED") {
      setModalIsOpen(false);
      setModalClosed(true);
      dispatch(setDonationStatus(""));
      dispatch(setDonationFrom(""));
      setThankYou(true);
    }
  }, [donationStatus]);
  

  return (
    <>
      <header className="header-top-strip py-1">
        <div className="size-header px-2 px-md-4 px-lg-4">
          <div className="row justify-content-center">
            <div className="col-lg-4 col-md-4 col-9 p-0 ps-2">
              <div className="logo py-2">
                <Link
                  to={
                    isBrowsePage || isVendorDetailsPage || isInvoicePaymentPage
                      ? "/majesticHomePage"
                      : isMajesticHomePage
                      ? "/weddingvendors?selected=vendors-grid"
                      : "/home"
                  }
                  onClick={(e) =>
                    handleNavigation(
                      isBrowsePage ||
                        isVendorDetailsPage ||
                        isInvoicePaymentPage
                        ? "/majesticHomePage"
                        : isMajesticHomePage
                        ? "/weddingvendors?selected=vendors-grid"
                        : "/home",
                      e
                    )
                  }
                >
                  {isBrowsePage ||
                  isMajesticHomePage ||
                  isVendorDetailsPage ||
                  isInvoicePaymentPage ? (
                    <img
                      className="d-lg-block wc-logo2"
                      src={Magisticlogo}
                      alt="logo"
                    />
                  ) : (
                    <img className="d-lg-block wc-logo" src={Sikh} alt="logo" />
                  )}
                </Link>
              </div>
            </div>
            <div
              className="col-lg-8 col-md-8 col-3 px-0"
              style={{ overflow: "visible" }}
            >
              <div className="text-end text-end">
                <div className="my__account userst">
                  <nav
                    className="navbar navbar-expand-lg navbar-light justify-content-end"
                    style={{ position: "relative" }}
                  >
                    <button
                      className="navbar-toggler mt-0 px-3 py-1"
                      type="button"
                      onClick={toggleCollapse}
                    >
                      {/* <span className="navbar-toggler-icon"></span> */}
                      <MdMenu size={25} color="var(--button-bg)" />
                    </button>
                    <div
                      className={`collapse navbar-collapse mobile-dropdown  ${
                        showCollapse ? "show" : ""
                      } mobile-dropdown-menu`}
                    >
                      <ul
                        className="navbar-nav ms-auto p-0 align-items-center toggle-nav-bar mb-nav"
                        style={{ gap: "18px" }}
                      >
                        <span
                          role="button"
                          className="text menu-list-navitems lead"
                          onClick={toggleGurdwaraModal}
                          style={{
                            color:
                              modal ||
                              location.pathname.startsWith("/bookGurdwara")
                                ? "var(--theme-letters)"
                                : "var(--letters)",
                            fontWeight:
                              modal ||
                              location.pathname.startsWith("/bookGurdwara")
                                ? "bold"
                                : "normal",
                            cursor: "pointer",
                            fontSize: "15px",
                            whiteSpace: "nowrap",
                            textDecoration: "none",
                            fontFamily: "sans-serif",
                            borderBottom:
                              modal ||
                              location.pathname.startsWith("/bookGurdwara")
                                ? "2px solid var(--theme-border)"
                                : "none",
                            transition: "border-bottom 0.2s",
                          }}
                        >
                          Book a Gurdwara
                        </span>
                        <Link
                          className="text menu-list-navitems lead"
                          onClick={(e) => {
                            dispatch(resetImageData());
                            handleNavigation(
                              "/weddingvendors?selected=entertainment&type=allmedia",
                              e
                            );
                          }}
                          style={{
                            fontSize: "15px",
                            fontFamily: "sans-serif",
                            color: location.search.includes(
                              "selected=entertainment"
                            )
                              ? "var(--theme-letters)"
                              : "var(--letters)",
                            fontWeight: location.search.includes(
                              "selected=entertainment"
                            )
                              ? "bold"
                              : "normal",
                            borderBottom: location.search.includes(
                              "selected=entertainment"
                            )
                              ? "2px solid var(--theme-border)"
                              : "none",
                            textDecoration: "none",
                            transition: "border-bottom 0.2s",
                            cursor: "pointer",
                          }}
                        >
                          Entertainment
                        </Link>

                        <div>
                          <Button
                            id="vendors-button"
                            aria-controls={
                              openVendors ? "vendors-menu" : undefined
                            }
                            aria-haspopup="true"
                            aria-expanded={openVendors ? "true" : undefined}
                            onClick={(e) => setAnchorVendors(e.currentTarget)}
                            style={{
                              fontSize: "15px",
                              fontFamily: "sans-serif",
                              color: location.pathname.startsWith(
                                "/weddingvendors?selected=vendors-grid"
                              )
                                ? "var(--theme-letters)"
                                : "var(--letters)",
                              fontWeight: location.pathname.startsWith(
                                "/weddingvendors?selected=vendors-grid"
                              )
                                ? "bold"
                                : "normal",
                              textTransform: "none",
                              background: "transparent",
                              boxShadow: "none",
                              flexDirection: "row",
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                            }}
                          >
                            Vendors
                            <AiFillCaretDown style={{ fontSize: "12px" }} />
                          </Button>

                          <Menu
                            id="vendors-menu"
                            anchorEl={anchorVendors}
                            open={Boolean(anchorVendors)}
                            onClose={() => setAnchorVendors(null)}
                            TransitionComponent={Fade}
                            disableScrollLock={true}
                            PaperProps={{
                              sx: {
                                mt: 1,
                                borderRadius: 2,
                                boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                                minWidth: 130,
                                py: 1,
                              },
                            }}
                            MenuListProps={{
                              sx: { padding: 0 },
                            }}
                          >
                            {/* Vendor View */}
                            <MenuItem
                              onClick={() => {
                                dispatch(resetImageData());
                                navigate(
                                  "/weddingvendors?selected=vendors-grid"
                                );
                                setAnchorVendors(null);
                              }}
                              sx={{
                                fontSize: 14,
                                py: 1.2,
                                backgroundColor:
                                  location.pathname ===
                                    "/weddingvendors?selected=vendors-grid" &&
                                  !new URLSearchParams(location.search).get(
                                    "selected"
                                  )
                                    ? "var(--button-bg)" // light purple highlight
                                    : "transparent",
                                color:
                                  location.pathname ===
                                    "/weddingvendors?selected=vendors-grid" &&
                                  !new URLSearchParams(location.search).get(
                                    "selected"
                                  )
                                    ? "var(--theme-letters)"
                                    : "var(--letters)",
                                fontWeight:
                                  location.pathname ===
                                    "/weddingvendors?selected=vendors-grid" &&
                                  !new URLSearchParams(location.search).get(
                                    "selected"
                                  )
                                    ? "bold"
                                    : "normal",
                              }}
                            >
                              <FaUsers size={15} style={{ marginRight: 8 }} />{" "}
                              Vendors
                            </MenuItem>

                            {/* Explore View */}
                            <MenuItem
                              onClick={() => {
                                dispatch(resetImageData());
                                navigate("/weddingvendors?selected=explorer");
                                setAnchorVendors(null);
                              }}
                              sx={{
                                fontSize: 14,
                                py: 1.2,
                                backgroundColor:
                                  location.pathname === "/weddingvendors" &&
                                  new URLSearchParams(location.search).get(
                                    "selected"
                                  ) === "explorer"
                                    ? "var(--button-bg)"
                                    : "transparent",
                                color:
                                  location.pathname === "/weddingvendors" &&
                                  new URLSearchParams(location.search).get(
                                    "selected"
                                  ) === "explorer"
                                    ? "var(--theme-letters)"
                                    : "var(--letters)",
                                fontWeight:
                                  location.pathname === "/weddingvendors" &&
                                  new URLSearchParams(location.search).get(
                                    "selected"
                                  ) === "explorer"
                                    ? "bold"
                                    : "normal",
                              }}
                            >
                              <FaCompass size={15} style={{ marginRight: 8 }} />{" "}
                              Explore
                            </MenuItem>
                          </Menu>
                        </div>

                        <Link
                          className="text menu-list-navitems lead"
                          to="/Localcommunityads"
                          style={{
                            fontSize: "15px",
                            fontFamily: "sans-serif",
                            color:
                              location.pathname === "/" ||
                              location.pathname.startsWith("/Localcommunityads")
                                ? "var(--theme-letters)"
                                : "var(--letters)",
                            fontWeight:
                              location.pathname === "/" ||
                              location.pathname.startsWith("/Localcommunityads")
                                ? "bold"
                                : "normal",
                            borderBottom:
                              location.pathname === "/" ||
                              location.pathname.startsWith("/Localcommunityads")
                                ? "2px solid var(--theme-border)"
                                : "none",
                            textDecoration: "none",
                            transition: "border-bottom 0.2s",
                          }}
                          onClick={(e) =>
                            handleNavigation("/Localcommunityads", e)
                          }
                        >
                          Ads
                        </Link>
                        {/* <Link
                          className="text menu-list-navitems lead"
                          to="/people-in-mycommunity"
                          style={{
                            fontSize: "15px",
                            fontFamily: "sans-serif",
                            color: location.pathname.startsWith(
                              "/people-in-mycommunity"
                            )
                              ? "var(--theme-letters)"
                              : "var(--letters)",
                            fontWeight: location.pathname.startsWith(
                              "/people-in-mycommunity"
                            )
                              ? "bold"
                              : "normal",
                            borderBottom: location.pathname.startsWith(
                              "/people-in-mycommunity"
                            )
                              ? "2px solid var(--theme-border)"
                              : "none",
                            textDecoration: "none",
                            transition: "border-bottom 0.2s",
                          }}
                          onClick={handlePeopleClick}
                        >
                          People
                        </Link>
                        <Link
                          className="text menu-list-navitems lead"
                          to="/items-for-sale"
                          style={{
                            fontSize: "15px",
                            fontFamily: "sans-serif",
                            color: location.pathname.startsWith(
                              "/items-for-sale"
                            )
                              ? "var(--theme-letters)"
                              : "var(--letters)",
                            fontWeight: location.pathname.startsWith(
                              "/items-for-sale"
                            )
                              ? "bold"
                              : "normal",
                            borderBottom: location.pathname.startsWith(
                              "/items-for-sale"
                            )
                              ? "2px solid var(--theme-border)"
                              : "none",
                            textDecoration: "none",
                            transition: "border-bottom 0.2s",
                          }}
                          onClick={handleItemsClick}
                        >
                          Items
                        </Link> */}
                        {islogin && (
                          <div onClick={handleInboxClick}>
                            <div
                              style={{
                                position: "relative",
                                cursor: "pointer",
                              }}
                              className="menu-list-navitems"
                            >
                              {isAdmin ? (
                                <FaInbox size={25} />
                              ) : (
                                <StyledBadge
                                  badgeContent={headerCounts.messageCount || ""}
                                  color="secondary"
                                  showZero
                                  anchorOrigin={{
                                    vertical: "top",
                                    horizontal: "right",
                                  }}
                                >
                                  <FaInbox size={25} className="inbox-icon" />
                                </StyledBadge>
                              )}
                            </div>
                          </div>
                        )}
                        {/* <div className="menu-list-navitems">
                          <MyCart />
                        </div> */}
                        {islogin && (
                          <div className="menu-list-navitems">
                            <div
                              className="notification-bell"
                              onClick={() => setShowNotifications(true)}
                            >
                              {isAdmin ? (
                                <FaBell className="bell-icon" />
                              ) : (
                                <StyledBadge
                                  badgeContent={
                                    headerCounts.notificationCount || ""
                                  }
                                  color="secondary"
                                  showZero
                                  anchorOrigin={{
                                    vertical: "top",
                                    horizontal: "right",
                                  }}
                                >
                                  <FaBell className="bell-icon" />
                                </StyledBadge>
                              )}

                              {/* {notifications.length > 0 && (
                                <span className="notif-badge">
                                  {headerCounts.notificationCount || ""}
                                </span>
                              )} */}
                            </div>
                            <Notification
                              open={showNotifications}
                              onClose={() => setShowNotifications(false)}
                            />
                          </div>
                        )}

                        {islogin ? (
                          <div
                            className="d-flex align-items-center text-white"
                            to={"/login"}
                          >
                            <div className="userimgdiv">
                              <span className="userimg">
                                <img
                                  src={
                                    user?.Photo
                                      ? user?.Photo
                                      : "https://st4.depositphotos.com/6672868/20448/v/600/depositphotos_204485038-stock-illustration-user-vector-icon-simple-illustration.jpg"
                                  }
                                  alt={user?.UserName?.split(
                                    "@"
                                  )[0].trim()}
                                  style={{
                                    borderRadius: "50%",
                                    height: "30px",
                                    width: "35px",
                                    objectFit: "cover",
                                  }}
                                />
                              </span>
                            </div>
                            <div className="dropdown">
                              <div>
                                <Button
                                  id="fade-button3"
                                  aria-controls={
                                    open22 ? "fade-menu3" : undefined
                                  }
                                  aria-haspopup="true"
                                  aria-expanded={open22 ? "true" : undefined}
                                  className="username"
                                  onClick={handleClick22}
                                >
                                  <div className="d-flex align-items-center">
                                    <strong>
                                      {user && truncatedUsername.toLowerCase()}
                                    </strong>
                                    <span className="userdropicon">
                                      <AiFillCaretDown />
                                    </span>
                                  </div>
                                </Button>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="d-flex align-items-center gap-10 menu-list-navitems">
                            <Link
                              to={"/login"}
                              onClick={(e) => {
                                handleNavigation("/login", e);
                                setOpen(1);
                              }}
                            >
                              <p className="mb-0"> Login </p>
                            </Link>{" "}
                            |
                            <Link
                              to="/signup"
                              onClick={(e) => handleNavigation("/signup", e)}
                            >
                              <p className="mb-0"> Sign Up </p>
                            </Link>
                          </div>
                        )}
                        <div className=" ">
                          <Menu
                            id="fade-menu3"
                            className="d-flex flex-column align-items-center text-center"
                            anchorEl={anchorEl22}
                            open={open22}
                            onClose={handleClose22}
                            TransitionComponent={Fade}
                            disableScrollLock={true}
                            PaperProps={{
                              sx: {
                                mt: 1,
                                borderRadius: 2,
                                boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                                minWidth: 220,
                                py: 1,
                              },
                            }}
                            MenuListProps={{
                              sx: {
                                padding: 0,
                              },
                            }}
                          >
                            {/* Dashboard */}
                            <MenuItem
                              component={Link}
                              to="/dashboardpage"
                              onClick={handleClose22}
                              sx={{
                                fontSize: 14,
                                py: 1.2,
                                width: "100%",
                                textDecoration: "none",
                                color: "inherit",
                                 
                              }}
                            >
                              Dashboard
                            </MenuItem>

                            {/* Profile */}
                            <MenuItem
                              component={Link}
                              to="/dashboardpage/settings"
                              onClick={handleClose22}
                              sx={{
                                fontSize: 14,
                                py: 1.2,
                                width: "100%",
                                textDecoration: "none",
                                color: "inherit",
                               
                              }}
                            >
                              Profile
                            </MenuItem>

                            {/* Call Us */}
                            <MenuItem
                              component="a"
                              href="tel:+15106163198"
                              sx={{
                                fontSize: 14,
                                py: 1.2,
                                color: "#28a745",
                                width: "100%",
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                              
                                textDecoration: "none",
                              }}
                            >
                              <FaPhoneAlt size={16} color="#28a745" /> Call Us
                            </MenuItem>

                            {/* Donate */}
                            <MenuItem
                              onClick={handleDonate}
                              sx={{
                                fontSize: 14,
                                py: 1.2,
                                width: "100%",
                                textDecoration: "none",
                                color: "inherit",
                                // borderBottom: "1px solid var(--theme-border)",
                              }}
                            >
                              Donate to Gurdwara
                            </MenuItem>

                            {/* Logout */}
                            <MenuItem
                              onClick={userLogout}
                              sx={{
                                fontSize: 14,
                                py: 1.2,
                                width: "100%",
                                color: "red",
                                fontWeight: 500,
                                textDecoration: "none",
                                // borderBottom: "1px solid var(--theme-border)",
                                // hover
                                "&:hover": {
                                  color: "red",
                                },
                              }}
                            >
                              Logout
                            </MenuItem>
                          </Menu>
                        </div>
                        {modalIsOpen && (
                          <DonateModal
                            modalIsOpen={modalIsOpen}
                            setModalIsOpen={setModalIsOpen}
                            onClose={() => {
                              setModalClosed(true);
                              setModalIsOpen(false);
                            }}
                            handleFormSubmit={true}
                          />
                        )}
                        <Menu
                          id="fade-menu2"
                          anchorEl={anchorCall}
                          open={openCall}
                          onClose={handleCloseCall}
                          TransitionComponent={Fade}
                        >
                          <Link
                            className="text-dark menu-list-navitems"
                            style={{
                              fontFamily: "sans-serif",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <MenuItem
                              onClick={() => {
                                toggleCollapse();
                                window.location.href = "tel:+15106163198";
                                handleCloseCall();
                              }}
                            >
                              <FaPhoneAlt
                                className="rounded-circle"
                                style={{
                                  padding: "2px",
                                  fontSize: "large",
                                }}
                              />{" "}
                              <small>Call (510)616-3198</small>
                            </MenuItem>
                          </Link>
                        </Menu>
                      </ul>
                    </div>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <ThankYouModal
        show={thankYou}
        onHide={() => setThankYou(false)}
        state={{ donation: true }}
      />
      {modal && (
        <SelectGurdwaraModal
          isOpen={modal}
          toggleModal={toggleGurdwaraModal}
          gurdwaraId={gurdwaraId}
          setGurdwaraId={setGurdwaraId}
          gurdwaraName={gurdwaraName}
          setGurdwaraName={setGurdwaraName}
        />
      )}
    </>
  );
};

export default Header;
